import SmsVerification from './sms-verification';

export default SmsVerification;
